export const getTableId = (tableName: string) => {
  return `crm-${tableName}-table`;
};
